/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as SettingsRouteImport } from './routes/settings';
import { Route as RulesRouteImport } from './routes/rules';
import { Route as OrderConfirmationsRouteImport } from './routes/order-confirmations';
import { Route as NotificationsRouteImport } from './routes/notifications';
import { Route as LoginRouteImport } from './routes/login';
import { Route as CustomerOrdersRouteImport } from './routes/customer-orders';
import { Route as AdminRouteImport } from './routes/admin';
import { Route as IndexRouteImport } from './routes/index';
import { Route as OrderConfirmationsIndexRouteImport } from './routes/order-confirmations.index';
import { Route as InvoicesIndexRouteImport } from './routes/invoices.index';
import { Route as CustomerOrdersIndexRouteImport } from './routes/customer-orders.index';
import { Route as OrderConfirmationsRulesRouteImport } from './routes/order-confirmations.rules';
import { Route as InvoicesIdRouteImport } from './routes/invoices.$id';
import { Route as CustomerOrdersRulesRouteImport } from './routes/customer-orders.rules';
import { Route as AdminUsersIdRouteImport } from './routes/admin.users.$id';
import { Route as AdminTenantsIdRouteImport } from './routes/admin.tenants.$id';

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any);
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any);
const OrderConfirmationsRoute = OrderConfirmationsRouteImport.update({
  id: '/order-confirmations',
  path: '/order-confirmations',
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const CustomerOrdersRoute = CustomerOrdersRouteImport.update({
  id: '/customer-orders',
  path: '/customer-orders',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const OrderConfirmationsIndexRoute = OrderConfirmationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrderConfirmationsRoute,
} as any);
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => rootRouteImport,
} as any);
const CustomerOrdersIndexRoute = CustomerOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CustomerOrdersRoute,
} as any);
const OrderConfirmationsRulesRoute = OrderConfirmationsRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => OrderConfirmationsRoute,
} as any);
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const CustomerOrdersRulesRoute = CustomerOrdersRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => CustomerOrdersRoute,
} as any);
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AdminRoute,
} as any);
const AdminTenantsIdRoute = AdminTenantsIdRouteImport.update({
  id: '/tenants/$id',
  path: '/tenants/$id',
  getParentRoute: () => AdminRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/admin': typeof AdminRouteWithChildren;
  '/customer-orders': typeof CustomerOrdersRouteWithChildren;
  '/login': typeof LoginRoute;
  '/notifications': typeof NotificationsRoute;
  '/order-confirmations': typeof OrderConfirmationsRouteWithChildren;
  '/rules': typeof RulesRoute;
  '/settings': typeof SettingsRoute;
  '/customer-orders/rules': typeof CustomerOrdersRulesRoute;
  '/invoices/$id': typeof InvoicesIdRoute;
  '/order-confirmations/rules': typeof OrderConfirmationsRulesRoute;
  '/customer-orders/': typeof CustomerOrdersIndexRoute;
  '/invoices/': typeof InvoicesIndexRoute;
  '/order-confirmations/': typeof OrderConfirmationsIndexRoute;
  '/admin/tenants/$id': typeof AdminTenantsIdRoute;
  '/admin/users/$id': typeof AdminUsersIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/admin': typeof AdminRouteWithChildren;
  '/login': typeof LoginRoute;
  '/notifications': typeof NotificationsRoute;
  '/rules': typeof RulesRoute;
  '/settings': typeof SettingsRoute;
  '/customer-orders/rules': typeof CustomerOrdersRulesRoute;
  '/invoices/$id': typeof InvoicesIdRoute;
  '/order-confirmations/rules': typeof OrderConfirmationsRulesRoute;
  '/customer-orders': typeof CustomerOrdersIndexRoute;
  '/invoices': typeof InvoicesIndexRoute;
  '/order-confirmations': typeof OrderConfirmationsIndexRoute;
  '/admin/tenants/$id': typeof AdminTenantsIdRoute;
  '/admin/users/$id': typeof AdminUsersIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/admin': typeof AdminRouteWithChildren;
  '/customer-orders': typeof CustomerOrdersRouteWithChildren;
  '/login': typeof LoginRoute;
  '/notifications': typeof NotificationsRoute;
  '/order-confirmations': typeof OrderConfirmationsRouteWithChildren;
  '/rules': typeof RulesRoute;
  '/settings': typeof SettingsRoute;
  '/customer-orders/rules': typeof CustomerOrdersRulesRoute;
  '/invoices/$id': typeof InvoicesIdRoute;
  '/order-confirmations/rules': typeof OrderConfirmationsRulesRoute;
  '/customer-orders/': typeof CustomerOrdersIndexRoute;
  '/invoices/': typeof InvoicesIndexRoute;
  '/order-confirmations/': typeof OrderConfirmationsIndexRoute;
  '/admin/tenants/$id': typeof AdminTenantsIdRoute;
  '/admin/users/$id': typeof AdminUsersIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/admin'
    | '/customer-orders'
    | '/login'
    | '/notifications'
    | '/order-confirmations'
    | '/rules'
    | '/settings'
    | '/customer-orders/rules'
    | '/invoices/$id'
    | '/order-confirmations/rules'
    | '/customer-orders/'
    | '/invoices/'
    | '/order-confirmations/'
    | '/admin/tenants/$id'
    | '/admin/users/$id';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/notifications'
    | '/rules'
    | '/settings'
    | '/customer-orders/rules'
    | '/invoices/$id'
    | '/order-confirmations/rules'
    | '/customer-orders'
    | '/invoices'
    | '/order-confirmations'
    | '/admin/tenants/$id'
    | '/admin/users/$id';
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/customer-orders'
    | '/login'
    | '/notifications'
    | '/order-confirmations'
    | '/rules'
    | '/settings'
    | '/customer-orders/rules'
    | '/invoices/$id'
    | '/order-confirmations/rules'
    | '/customer-orders/'
    | '/invoices/'
    | '/order-confirmations/'
    | '/admin/tenants/$id'
    | '/admin/users/$id';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AdminRoute: typeof AdminRouteWithChildren;
  CustomerOrdersRoute: typeof CustomerOrdersRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  NotificationsRoute: typeof NotificationsRoute;
  OrderConfirmationsRoute: typeof OrderConfirmationsRouteWithChildren;
  RulesRoute: typeof RulesRoute;
  SettingsRoute: typeof SettingsRoute;
  InvoicesIdRoute: typeof InvoicesIdRoute;
  InvoicesIndexRoute: typeof InvoicesIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/rules': {
      id: '/rules';
      path: '/rules';
      fullPath: '/rules';
      preLoaderRoute: typeof RulesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/order-confirmations': {
      id: '/order-confirmations';
      path: '/order-confirmations';
      fullPath: '/order-confirmations';
      preLoaderRoute: typeof OrderConfirmationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/notifications': {
      id: '/notifications';
      path: '/notifications';
      fullPath: '/notifications';
      preLoaderRoute: typeof NotificationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/customer-orders': {
      id: '/customer-orders';
      path: '/customer-orders';
      fullPath: '/customer-orders';
      preLoaderRoute: typeof CustomerOrdersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin': {
      id: '/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/order-confirmations/': {
      id: '/order-confirmations/';
      path: '/';
      fullPath: '/order-confirmations/';
      preLoaderRoute: typeof OrderConfirmationsIndexRouteImport;
      parentRoute: typeof OrderConfirmationsRoute;
    };
    '/invoices/': {
      id: '/invoices/';
      path: '/invoices';
      fullPath: '/invoices/';
      preLoaderRoute: typeof InvoicesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/customer-orders/': {
      id: '/customer-orders/';
      path: '/';
      fullPath: '/customer-orders/';
      preLoaderRoute: typeof CustomerOrdersIndexRouteImport;
      parentRoute: typeof CustomerOrdersRoute;
    };
    '/order-confirmations/rules': {
      id: '/order-confirmations/rules';
      path: '/rules';
      fullPath: '/order-confirmations/rules';
      preLoaderRoute: typeof OrderConfirmationsRulesRouteImport;
      parentRoute: typeof OrderConfirmationsRoute;
    };
    '/invoices/$id': {
      id: '/invoices/$id';
      path: '/invoices/$id';
      fullPath: '/invoices/$id';
      preLoaderRoute: typeof InvoicesIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/customer-orders/rules': {
      id: '/customer-orders/rules';
      path: '/rules';
      fullPath: '/customer-orders/rules';
      preLoaderRoute: typeof CustomerOrdersRulesRouteImport;
      parentRoute: typeof CustomerOrdersRoute;
    };
    '/admin/users/$id': {
      id: '/admin/users/$id';
      path: '/users/$id';
      fullPath: '/admin/users/$id';
      preLoaderRoute: typeof AdminUsersIdRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/tenants/$id': {
      id: '/admin/tenants/$id';
      path: '/tenants/$id';
      fullPath: '/admin/tenants/$id';
      preLoaderRoute: typeof AdminTenantsIdRouteImport;
      parentRoute: typeof AdminRoute;
    };
  }
}

interface AdminRouteChildren {
  AdminTenantsIdRoute: typeof AdminTenantsIdRoute;
  AdminUsersIdRoute: typeof AdminUsersIdRoute;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminTenantsIdRoute: AdminTenantsIdRoute,
  AdminUsersIdRoute: AdminUsersIdRoute,
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

interface CustomerOrdersRouteChildren {
  CustomerOrdersRulesRoute: typeof CustomerOrdersRulesRoute;
  CustomerOrdersIndexRoute: typeof CustomerOrdersIndexRoute;
}

const CustomerOrdersRouteChildren: CustomerOrdersRouteChildren = {
  CustomerOrdersRulesRoute: CustomerOrdersRulesRoute,
  CustomerOrdersIndexRoute: CustomerOrdersIndexRoute,
};

const CustomerOrdersRouteWithChildren = CustomerOrdersRoute._addFileChildren(
  CustomerOrdersRouteChildren,
);

interface OrderConfirmationsRouteChildren {
  OrderConfirmationsRulesRoute: typeof OrderConfirmationsRulesRoute;
  OrderConfirmationsIndexRoute: typeof OrderConfirmationsIndexRoute;
}

const OrderConfirmationsRouteChildren: OrderConfirmationsRouteChildren = {
  OrderConfirmationsRulesRoute: OrderConfirmationsRulesRoute,
  OrderConfirmationsIndexRoute: OrderConfirmationsIndexRoute,
};

const OrderConfirmationsRouteWithChildren =
  OrderConfirmationsRoute._addFileChildren(OrderConfirmationsRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  CustomerOrdersRoute: CustomerOrdersRouteWithChildren,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  OrderConfirmationsRoute: OrderConfirmationsRouteWithChildren,
  RulesRoute: RulesRoute,
  SettingsRoute: SettingsRoute,
  InvoicesIdRoute: InvoicesIdRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
